/* @flow */

import type { RootState, Action } from '../types'

import { ActionRequiresPropertyError } from '../helpers'

export const SET_IS_CURRENT_USER_FETCHED: string =
  'opinary/SET_IS_CURRENT_USER_FETCHED'

export const STATE_KEY: string = 'isCurrentUserFetched'

export function setIsCurrentUserFetched(value: boolean = true): Action {
  return {
    type: SET_IS_CURRENT_USER_FETCHED,
    value,
  }
}

export function selectIsCurrentUserFetched(rootState: RootState): boolean {
  return rootState[STATE_KEY]
}

export default function reducer(state: boolean = false, action: Action) {
  switch (action.type) {
    case SET_IS_CURRENT_USER_FETCHED:
      if (action.value == null) {
        throw new ActionRequiresPropertyError(
          SET_IS_CURRENT_USER_FETCHED,
          'value'
        )
      } else {
        return action.value
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/stores/isCurrentUserFetched.js